import { authedJson } from '../api/client';

export type ProjectStatus = 'ACTIVE' | 'DONE' | 'ARCHIVED';

export interface Project {
  projectId: string;
  workspaceId: string;
  epicId: string;
  name: string;
  description: string;
  status: ProjectStatus;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const projectsApi = {
  list: (workspaceId: string, epicId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ projects: Project[] }>(
      `/workspaces/${workspaceId}/epics/${epicId}/projects`,
      { method: 'GET' },
      getToken,
      doRefresh,
    ),

  create: (
    workspaceId: string,
    epicId: string,
    name: string,
    description: string,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Project>(
      `/workspaces/${workspaceId}/epics/${epicId}/projects`,
      { method: 'POST', body: JSON.stringify({ name, description }) },
      getToken,
      doRefresh,
    ),

  get: (workspaceId: string, projectId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Project>(`/workspaces/${workspaceId}/projects/${projectId}`, { method: 'GET' }, getToken, doRefresh),

  update: (
    workspaceId: string,
    projectId: string,
    updates: Partial<Pick<Project, 'name' | 'description' | 'status'>>,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Project>(
      `/workspaces/${workspaceId}/projects/${projectId}`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, projectId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(`/workspaces/${workspaceId}/projects/${projectId}`, { method: 'DELETE' }, getToken, doRefresh),
};
